import React from 'react'
import styled from 'styled-components'
import { Cell, Icons } from '../../styles/styled-common'

const Check = Icons.Check

const Li = styled.li`
  .svg-icon {
    height: 1.3em;
    vertical-align: sub;
  }
`

const StCell = styled(Cell)`
  justify-content: start;
`

export default class CheckListCell extends React.PureComponent {
  render() {
    const { list, ...props } = this.props

    const items =
      list && list.map
        ? list.map((i, ix) => (
            <Li key={ix}>
              <span>
                <Check /> {i}
              </span>
            </Li>
          ))
        : null

    return (
      <StCell {...props}>
        <ul>{items}</ul>
      </StCell>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/CheckListCell.jsx